import React from "react";

function AboutSection() {
  const facts = [
    { value: "Full stack", label: "React · Node · .NET" },
    { value: "UNISA", label: "BSc Computing" },
    { value: "Umuzi", label: "Learnership alumni" },
    { value: "Mentor", label: "Junior developers" },
  ];

  return (
    <section id="about" className="t-about">
      <div>
        <h2 className="t-display t-title">
          About
          <br />
          <span className="t-text-yellow">Me</span>
        </h2>
        <div className="t-facts">
          {facts.map((f) => (
            <div key={f.value} className="t-fact">
              <strong>{f.value}</strong>
              <span>{f.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="t-about__body">
        <p>
          Hello! My name is Taelo Seholoba, and I'm a software developer with a
          strong passion for creating clean, efficient, and user-friendly
          applications. I thrive on solving complex problems and continuously
          learning new technologies to build innovative solutions.
        </p>
        <p>
          I specialize in full-stack web development, with a focus on React for
          dynamic front-end experiences and Node.js for robust back-end systems.
          My journey into software development began with a fascination for how
          digital products impact our daily lives, leading me to join a
          learnership program at Umuzi, where I developed practical skills in
          software development and digital technologies.
        </p>
        <p>
          Beyond coding, I enjoy exploring new frameworks and staying up-to-date
          with industry best practices. In my free time, I like watching anime,
          playing video games, and diving into sci-fi stories.
        </p>
        <p>
          I am always eager to connect with fellow developers, learn about
          exciting opportunities, and collaborate on impactful projects. Feel
          free to explore my work in the projects section!
        </p>
      </div>
    </section>
  );
}

export default AboutSection;
